import React from 'react'
import { LegalPage } from '@/components/legal/LegalPage'

export const PrivacyPage: React.FC = () => (
  <LegalPage
    titleKey="legal.privacy.title"
    sections={[
      { titleKey: 'legal.privacy.controllerTitle', contentKey: 'legal.privacy.controller' },
      { titleKey: 'legal.privacy.dataTitle', contentKey: 'legal.privacy.data' },
      { titleKey: 'legal.privacy.purposeTitle', contentKey: 'legal.privacy.purpose' },
      { titleKey: 'legal.privacy.legalBasisTitle', contentKey: 'legal.privacy.legalBasis' },
      { titleKey: 'legal.privacy.retentionTitle', contentKey: 'legal.privacy.retention' },
      { titleKey: 'legal.privacy.recipientsTitle', contentKey: 'legal.privacy.recipients' },
      { titleKey: 'legal.privacy.rightsTitle', contentKey: 'legal.privacy.rights' },
    ]}
  />
)
